<template>
  <div>
    <b-card ref="container" id="container">
      <div class="ticket-center-main">
        <List />
      </div>
    </b-card>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from "@/auth/jwt/useJwt";
import List from "./List.vue";
import { BCard } from "bootstrap-vue";

export default {
  components: {
    List,
    BCard
  },
  data: () => ({
    socket: null,
  }),
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },

  created() {
    console.log("userdata", this.userData);
  },

  setup() {

    return {

    };
  },
};
</script>
<style lang="scss" scoped>
</style>